const alpha3ToAlpha2: Record<string, string> = {
  USA: 'US',
  CHE: 'CH',
  ARE: 'AE',
  IRL: 'IE',
  GRC: 'GR',
  PRT: 'PT',
  ISL: 'IS',
  ARG: 'AR',
  AUS: 'AU',
  AUT: 'AT',
  BEL: 'BE',
  BMU: 'BM',
  BRA: 'BR',
  CAN: 'CA',
  CHL: 'CL',
  CHN: 'CN',
  COL: 'CO',
  CYM: 'KY',
  CZE: 'CZ',
  DEU: 'DE',
  DNK: 'DK',
  EGY: 'EG',
  ESP: 'ES',
  EST: 'EE',
  FIN: 'FI',
  FRA: 'FR',
  HUN: 'HU',
  IDN: 'ID',
  IND: 'IN',
  ISR: 'IL',
  ITA: 'IT',
  JPN: 'JP',
  JAP: 'JP',
  KOR: 'KR',
  LKA: 'LK',
  LTU: 'LT',
  LVA: 'LV',
  MEX: 'MX',
  MYS: 'MY',
  NLD: 'NL',
  NOR: 'NO',
  NZL: 'NZ',
  PER: 'PE',
  PHL: 'PH',
  POL: 'PL',
  ROU: 'RO',
  RUS: 'RU',
  SAU: 'SA',
  SGP: 'SG',
  SVK: 'SK',
  SVN: 'SI',
  SWE: 'SE',
  THA: 'TH',
  TUR: 'TR',
  TWN: 'TW',
  UAE: 'AE',
  VNM: 'VN',
  ZAF: 'ZA',
  GBR: 'GB',
  EUR: 'EU',
};

const regionalCodes = ['EM', 'LATAM', 'ASIA', 'ASIAXJ', 'WOR'];

export const convertCountryCodeToAlpha2 = (
  countryCode: string
): string | null => {
  const upperCode = countryCode.toUpperCase();

  if (upperCode.length === 2) {
    if (regionalCodes.includes(upperCode)) {
      return null;
    }

    return upperCode;
  }

  if (upperCode.length === 3) {
    return alpha3ToAlpha2[upperCode] || null;
  }

  return null;
};

export const isRegionalCode = (countryCode: string): boolean => {
  return regionalCodes.includes(countryCode.toUpperCase());
};
